unit UWeb.Enum;

interface

type
  TPerfil = (SEM_PREFIL, FACIL_SISTEMAS, PARCEIRO, ALIADO);

  TServidor = (SERVICE, MENSAGENS, WHATSAPP, PAINEL_ALIADOS);

  TTipoPermissao = (VISUALIZAR, INSERIR, ALTERAR, EXCLUIR);
implementation

end.
